import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const SkeletonMoreUpdateItem: React.FC = () => {
  return (
    <div
      className="more_update_listing d-flex placeholder-glow"
      style={{ textDecoration: "none" }}
    >
      {/* Thumbnail */}
      <div className="img_thumbnail me-3">
        <span
          className="placeholder rounded"
          style={{ width: "100px", height: "80px", display: "block" }}
        ></span>
      </div>

      {/* Text Content */}
      <div className="short_details upates_card_info flex-grow-1">
        {/* Update type */}
        <span
          className="placeholder col-4 mb-2 d-block"
          style={{ height: "14px", borderRadius: "4px" }}
        ></span>

        {/* Title */}
        <span
          className="placeholder col-10 d-block mb-2"
          style={{ height: "18px", borderRadius: "6px" }}
        ></span>
        <span
          className="placeholder col-7 d-block mb-3"
          style={{ height: "18px", borderRadius: "6px" }}
        ></span>

        {/* Date */}
        <span
          className="placeholder col-5 d-block"
          style={{ height: "14px", borderRadius: "4px" }}
        ></span>
      </div>
    </div>
  );
};

export default SkeletonMoreUpdateItem;
